import { MERET, NEFER } from './desert-chain-1.js';
/** Ser Givrecoeur, at the Company's quarter in Havrebourg (ADR 0067). */
const GIVRECOEUR = { mob: 'tutor', biome: 'meadow' };
/**
 * The dragon's mark in the desert (ADR 0067, `docs/LORE.md`): after the
 * Golden Jackal, Méret sends the player to La Plaine de verre, by the
 * Forgotten Obelisk, where Shefira's breath turned the sand to black glass.
 * The Obelisk cracked the same night; Néfer copies what its split face
 * hides, and Méret reads there the nameless king's pact and the first sleep.
 * Then the last keeper of that oath joins the Company before the road north opens.
 */
export const DESERT_DRAGON_QUESTS = [
    {
        id: 'desert-glass',
        name: 'La Plaine de verre',
        biome: 'desert',
        level: 16,
        requires: ['desert-jackal'],
        giver: MERET,
        turnIn: NEFER,
        offer: 'Je te dois un secret que ma famille garde depuis sept cents ans. Près de l’Obélisque, les caravaniers parlent d’une plaine où le sable s’est changé en verre noir, en une seule nuit, sans orage. Va voir. Chasse les salamandres qui s’y réchauffent, puis va voir Néfer. Ses vieilles pierres se souviennent de tout.',
        summary: 'Atteindre la Plaine de verre, près de l’Obélisque Oublié, écarter les salamandres, puis rejoindre Néfer.',
        pending: 'La plaine est près de l’Obélisque. Tu l’entendras craquer sous tes pieds avant de la voir.',
        complete: 'Le verre est encore tiède ! Et l’Obélisque s’est fendu en deux la même nuit. Sous la fissure, il y a des dessins que personne n’avait jamais vus. Ils parlent d’Ounas-Rê… et d’un feu qui vole.',
        objectives: [
            { kind: 'reach', label: 'Atteindre la Plaine de verre', landmark: 'La Plaine de verre' },
            {
                kind: 'kill',
                label: 'Salamandres de braise écartées',
                mobs: ['ember-salamander'],
                count: 15,
            },
        ],
        reward: { xp: 1100, gold: 220 },
    },
    {
        id: 'desert-pact',
        name: 'Le pacte effacé',
        biome: 'desert',
        level: 16,
        requires: ['desert-glass'],
        giver: NEFER,
        turnIn: MERET,
        offer: 'Je recopie les dessins de la fissure, mais les momies se sont réveillées autour de l’Obélisque et elles m’embêtent ! Éloigne-les le temps que je finisse. Ensuite, apporte ma copie à Méret. C’est la langue des prêtres, et elle est la dernière à la parler.',
        summary: 'Abattre les momies levées autour de l’Obélisque, puis porter le relevé de Néfer à la Prêtresse Méret.',
        pending: 'Donne-moi la copie de Néfer. Et croise les doigts pour que je lise mal.',
        complete: 'Malheureusement, je lis bien. Ounas-Rê avait passé un marché avec Shefira, le dragon : de l’or contre la paix. Quand le marché a été rompu, mes ancêtres et les gens du nord ont attiré le dragon sous la glace de Givrecime. Ils l’ont endormi avec une chaîne de givre autour du cou. Puis ils ont effacé le nom du roi partout. Et ce verre tiède veut dire que le dragon est passé par ici. Récemment.',
        objectives: [
            { kind: 'kill', label: 'Momies de l’Obélisque abattues', mobs: ['mummy'], count: 20 },
        ],
        reward: { xp: 1200, gold: 240 },
    },
    {
        id: 'desert-recruit',
        name: 'La dernière gardienne',
        biome: 'desert',
        level: 16,
        requires: ['desert-pact'],
        giver: MERET,
        turnIn: GIVRECOEUR,
        offer: 'La chaîne du dragon se relâche. Certaines nuits, elle se libère, brûle tout, puis le froid la rattrape avant l’aube. Mais ça ne durera pas. La copie se termine par une phrase que je ne comprends pas : « Que le froid siège au-dessus du feu, et le feu dormira. » Dis à ton chevalier que la dernière prêtresse du Chacal arrive à Havrebourg. Ce que mes ancêtres ont enfermé, c’est à moi de le renfermer.',
        summary: 'Retourner à Havrebourg et annoncer à Ser Givrecoeur que la Prêtresse Méret rejoint la Compagnie.',
        pending: 'Tu reviens du sud ? Assieds-toi et raconte-moi tout !',
        complete: 'Une prêtresse du Chacal ! C’est son peuple qui a endormi le dragon la première fois. « Que le froid siège au-dessus du feu »… Je suis né dans la neige de Givrecime, et je ne vois pas du tout ce que ça veut dire. Bienvenue parmi nous, Méret. On trouvera ensemble.',
        objectives: [{ kind: 'reach', label: 'Retourner à Havrebourg', landmark: 'Havrebourg' }],
        reward: { xp: 500, gold: 100 },
    },
];
//# sourceMappingURL=desert-dragon.js.map